import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/observable/of';
import { FormControl, Validators } from '@angular/forms';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { Page } from '../../../models/list/page.model';
import { ResultSearchPatientService } from './result-search-patient.service';
import { Utility } from '../../../common/utility';

@Component({
  selector: 'result-search-patient-nonbase',
  templateUrl: 'result-search-patient-nonbase.component.html',
  providers: [ResultSearchPatientService]
})

export class ResultSearchPatientNonBaseComponent implements OnInit {
  public patientPage = new Page();
  public patientDataRow = [];
  public clinicPage = new Page();
  public clinicDataRow = [];
  public dataMessage = {
    emptyMessage: AppMessages.list.noRecord, // Message to show when array is presented but contains no values
    totalMessage: AppMessages.list.total
  };
  public customClasses = AppConstants.table.footerClasses;
  @Input() filterParam;

  constructor(private resultSearchPatientService: ResultSearchPatientService, public utility: Utility
  ) { }

  ngOnInit() {
    this.patientPage.size = 30;
    this.setPatientPage({ offset: 0 });

    this.clinicPage.size = 5;
    this.setClinicPage({ offset: 0 });
  }

  setPatientPage(pageInfo) {
    this.patientPage.pageNumber = pageInfo.offset;
    // temporary bind data

    const param = {
      pageSize: this.patientPage.size,
      currentPage: this.patientPage.pageNumber + 1,
      reference: this.filterParam.reference,
      name: this.filterParam.name,
      userName: this.filterParam.userName,
      address: this.filterParam.address,
      email: this.filterParam.email,
      dateOfBirth: this.filterParam.dateofBirth,
      gender: this.filterParam.gender,
      organizationId: this.filterParam.organizationId,
      isInCentreSearch: false
    };
    // push our inital complete list
    this.resultSearchPatientService.getSimilarPatientList(param).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.patientDataRow = data['list'];
          this.patientPage.totalElements = data['totalRecords']; // this.patientDataRow[0].totalRecords;
          this.patientPage.totalPages = Math.ceil(this.patientPage.totalElements / this.patientPage.size);
        }

      }
    );
  }

  setClinicPage(pageInfo) {
    this.clinicPage.pageNumber = pageInfo.offset;
    // temporary bind data

    const param = {
      pageSize: this.clinicPage.size,
      currentPage: this.clinicPage.pageNumber + 1
    };

    // push our inital complete list
    this.resultSearchPatientService.getBaseClinic(param).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.clinicDataRow = data['list'];
          this.clinicPage.totalElements = data['totalRecords'];
          this.clinicPage.totalPages = Math.ceil(this.clinicPage.totalElements / this.clinicPage.size);
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/result-search-patient/result-search-patient-nonbase.component.ts